import { createContext, useContext, useMemo, type ReactNode } from 'react';
import { createFormatter, defaultLocale, type Formatter, type TenantLocale } from './formatter';

const FormatContext = createContext<Formatter | null>(null);

/** Provides the tenant's formatter to every screen below; the app mounts one per tenant. */
export function FormatProvider({
  locale = defaultLocale,
  children,
}: {
  locale?: TenantLocale;
  children: ReactNode;
}): ReactNode {
  const formatter = useMemo(() => createFormatter(locale), [locale]);
  return <FormatContext.Provider value={formatter}>{children}</FormatContext.Provider>;
}

const fallback = createFormatter();

/** The current formatter; the default locale when no provider is mounted (stories, tests). */
export function useFormat(): Formatter {
  return useContext(FormatContext) ?? fallback;
}
